import { useQuery } from '@tanstack/react-query';
import { request } from 'javascripts/services/v3ApiClient';
import type {
  V3ApiSuccessData,
  V3ApiError,
} from 'javascripts/services/v3ApiClient';
import { type PublicProfileObject } from 'data/v3/data-contracts';

import { PUBLIC_PROFILES_QUERY_KEY } from '../constants';

export type GetPublicProfilesResponse = V3ApiSuccessData<PublicProfileObject[]>;

export const useGetPublicProfiles = (enabled: boolean = true) => {
  return useQuery<GetPublicProfilesResponse, V3ApiError>({
    queryFn: async () => {
      const response = await request({
        url: `/companies/public_profiles`,
      });
      return {
        ...response.data,
        data: response.data.data.filter(
          (profile: PublicProfileObject) => profile.id,
        ),
      };
    },
    queryKey: [PUBLIC_PROFILES_QUERY_KEY],
    enabled,
  });
};
